import React from 'react';
import USPV2 from '@ajat/design-system/ContentBlocks/USPV2';
import { ComponentPage, DemoCard } from '../../shared';
import { USP_ITEMS } from './contentDemoData';

export const meta = {
  component: USPV2,
  title: 'USP V2',
  group: 'Content Blocks',
  importPath: '@ajat/design-system/ContentBlocks/USPV2',
  figmaNode: '2217:151754',
  description:
    'Quiet strip of label / value pairs separated by hairlines (OVER-LL). No icons, no Trustpilot — the counterpart of USP for the Overall brand. Items flagged hideOnMobile disappear below 1024px (Figma mobile 2645:13348 keeps two of four).',
  props: [
    ['items', 'array', '[]', '[{ label, value, hideOnMobile }]'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'On the OVER/LL landing',
      code: `import USPV2 from '@ajat/design-system/ContentBlocks/USPV2';

<USPV2
  items={[
    { label: 'Leverans', value: '2–4 dagar' },
    { label: 'Grupprabatt', value: 'Från 10 st', hideOnMobile: true },
    { label: 'Betalning', value: 'Kort · Swish' },
    { label: 'Kvalité', value: 'Premium canvas', hideOnMobile: true },
  ]}
/>`,
    },
  ],
};

export default function USPV2Page() {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Four pairs" hint="the 2nd and 4th hide below 1024px" flush>
        <USPV2 items={USP_ITEMS} />
      </DemoCard>
    </ComponentPage>
  );
}
